export default __webpack_public_path__ + "static/media/scene_05.be40a584.mp3";